import axios from "axios";
import { ApiConstant } from '../../../constants';

const token = localStorage.getItem('token');
if (token) {
    axios.defaults.headers.common.Authorization = token;
}
const getUserSoftSkillsStatus = async () => {
    try {
        const response = await axios.get(`${ApiConstant.BASE_URL}soft-skills/`);
        return response
    } catch (e) {
        return {
            data: {
                data: {
                    challenge: {}
                },
                success: false,
                error: e.message
            }
        };
    }
}

export {
    getUserSoftSkillsStatus
}